import { useEffect } from "react";
import { useLocation } from "react-router";
import {
  capturePostHogPageView,
  schedulePostHogInitialization,
} from "../../lib/analytics/posthog.client";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    schedulePostHogInitialization();
  }, []);

  // Route changes and early explicit events are queued in the small local
  // runtime, then replayed in order once the deferred client is ready.
  useEffect(() => {
    capturePostHogPageView(location.pathname);
  }, [location.pathname]);

  return <>{children}</>;
}
